module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"axRoadSearchResults":"Search Results"},"de":{"axRoadSearchResults":"Suchergebnisse"},"fr":{"axRoadSearchResults":"Résultats de la recherche"},"it":{"axRoadSearchResults":"Risultati della ricerca"}}')
  delete Component.options._Ctor
}
